/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

import { Logger } from '../logger';

const logger = Logger.getInstance();

class Opportunity {
  private _id: string;
  private creationTime: number = 0;

  constructor(id: string) {
    this._id = id;
    this.creationTime = Date.now();

    logger.debug(`Opportunity created with ID: ${this._id}`);
  }

  public get id(): string {
    return this._id;
  }

  /**
   * Returns the age of the opportunity in milliseconds.
   */
  public get age(): number {
    return Date.now() - this.creationTime;
  }

}

export { Opportunity };
